import { useEffect, useState } from 'react';
import { FaFileExcel, FaFilePdf } from 'react-icons/fa';
import Swal from 'sweetalert2';
import librosContablesService from '../services/librosContablesService';
import '../styles/pages/LibrosSIIPage.css';

const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const aniosDisponibles = () => {
  const actual = new Date().getFullYear();
  return [actual - 2, actual - 1, actual, actual + 1];
};

const LibroCajaPage = ({ token, id_company }) => {
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [estadoCierre, setEstadoCierre] = useState({});
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id_company) cargarEstado(anio);
  }, [anio, id_company]);

  const cargarEstado = async (year) => {
    setCargando(true);
    setError(null);
    try {
      const estado = await librosContablesService.getEstadoCierre(id_company, year, token);
      setEstadoCierre(estado);
    } catch {
      setError('Error al obtener el estado de cierre mensual.');
    } finally {
      setCargando(false);
    }
  };

  const handleDescarga = async (tipo, mes, nombreMes) => {
    Swal.fire({
      title: 'Generando archivo...',
      html: `Preparando el Libro de Caja de <b>${nombreMes} ${anio}</b>.<br/>Por favor espere.`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      if (tipo === 'excel') {
        await librosContablesService.descargarExcelLibroCaja(id_company, mes, anio, token);
      } else {
        await librosContablesService.descargarPdfLibroCaja(id_company, mes, anio, token);
      }
      Swal.close();
    } catch {
      Swal.fire({
        icon: 'error',
        title: 'Error al generar',
        text: 'No se pudo generar el archivo. El módulo de generación está pendiente de implementación.',
      });
    }
  };

  return (
    <div className="libros-sii">
      <h1 className="libros-sii__title">Libro de Caja SII</h1>
      <div className="libros-sii__controls">
        <label htmlFor="anio-select">Año:</label>
        <select
          id="anio-select"
          className="libros-sii__select"
          value={anio}
          onChange={(e) => setAnio(parseInt(e.target.value, 10))}
        >
          {aniosDisponibles().map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>

      {cargando && <p className="libros-sii__loading">Cargando...</p>}
      {error && <p className="libros-sii__error">{error}</p>}

      {!cargando && !error && (
        <table className="libros-sii__table">
          <thead>
            <tr>
              <th>Mes</th>
              <th>Estado</th>
              <th>Descargar PDF</th>
              <th>Descargar Excel</th>
            </tr>
          </thead>
          <tbody>
            {MESES.map((nombre, idx) => {
              const mes = idx + 1;
              const cerrado = !!estadoCierre[mes];
              return (
                <tr key={mes}>
                  <td>{nombre}</td>
                  <td>
                    <span className={`libros-sii__badge libros-sii__badge--${cerrado ? 'cerrado' : 'abierto'}`}>
                      {cerrado ? 'Cerrado' : 'Abierto'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="libros-sii__btn libros-sii__btn--pdf"
                      disabled={!cerrado}
                      onClick={() => handleDescarga('pdf', mes, nombre)}
                      title={cerrado ? 'Descargar PDF' : 'El período debe estar cerrado'}
                    >
                      <FaFilePdf />
                      PDF
                    </button>
                  </td>
                  <td>
                    <button
                      className="libros-sii__btn libros-sii__btn--excel"
                      disabled={!cerrado}
                      onClick={() => handleDescarga('excel', mes, nombre)}
                      title={cerrado ? 'Descargar Excel' : 'El período debe estar cerrado'}
                    >
                      <FaFileExcel />
                      Excel
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LibroCajaPage;
